import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MenuContentComponent } from '@core/layout/components/menu-content/menu-content.component';
import { SubMenuItem } from '@core/layout/models/menu.model';
import { MenuService } from '@core/layout/services/menu.service';

@Component({
  selector: 'app-sidebar',
  imports: [NgClass, NgClass, MenuContentComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  protected menuService = inject(MenuService);


  public toggleSidebar() {
    this.menuService.toggleSidebar();
  }

  public toggleMenu(subMenu: SubMenuItem) {
    this.menuService.toggleMenu(subMenu);
  }

  trackByGroup(index: number, group: any): string {
    return group.group || index;
  }

  trackByItem(index: number, item: any): string {
    return item.route || index;
  }
}
